import { PERMISSION } from '@/constants/permission.constant';

const transmissionList = () => import('@/views/configuration/transmissions/List.vue');
const transmissionAdd = () => import('@/views/configuration/transmissions/Add.vue');
const transmissionEdit = () => import('@/views/configuration/transmissions/Edit.vue');

export const transmissionRoute = [
  {
    path: '/configuration/transmissions',
    name: 'transmission',
    component: transmissionList,
    meta: { requiresAuth: false, permissions: [PERMISSION.TRANSMISSION_READ] },
  },

  {
    path: '/configuration/transmissions/create',
    name: 'transmission-create',
    component: transmissionAdd,
    meta: { requiresAuth: false, permissions: [PERMISSION.TRANSMISSION_CREATE] },
  },
  {
    path: '/configuration/transmissions/:id/edit',
    name: 'transmission-edit',
    component: transmissionEdit,
    meta: { requiresAuth: false, permissions: [PERMISSION.TRANSMISSION_UPDATE] },
  },
];
